import script from "./ViewAllManagers.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAllManagers.vue?vue&type=script&setup=true&lang=js"

import "./ViewAllManagers.vue?vue&type=style&index=0&id=6b2ded8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b2ded8c"]])

export default __exports__